module.exports = __webpack_public_path__ + "static/media/logo_blue.835ad5d9.png";